<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import { saleService } from "../../../services/saleservice/sale.service";
import { scheduleService } from "../../../services/saleservice/schedule.service";
import { propertyService } from "../../../services/propertyservice/property.service";
import { bookingService } from "../../../services/bookingservice/booking.service";
import { servicehelpers } from "../../../services/servicehelpers";
import i18n from "../../../i18n";
import Loading from "@/components/c-loading";
import PaymentTerm from "../../../components/modals/payment-term";
import PaymentSchedule from "../../../components/modals/payment-schedule";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Sale Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    Input,
    Dropzone,
    Select,
    Search,
    PaymentTerm,
    PaymentSchedule,
    // DropdownList
  },
  data() {
    return {
      dropdownSelection: {},
   
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "sale",
      breadCrumb: {},
      currency: "",
      project: 0,

      saleData: null,
      paymentSchedule: {},
      customerData: {},
      templeteData: {},
      projectData: {},
      accountTenderData: {},
      accountsaleData: {},
      propertyData: {},
      sellerData: {},
      agencyData: {},
      currencyData: {},
      discountTypeData: {},
      paymenttermData: {},
      commissionTypeData: {},
      accountCommissionExpenseData: {},
      accountCommissionPaidData: {},
      lastPayTypeData: {},
      dataDiscountText: '',
      property: {},
      dataProject: 0,
      dataLastProject: 0,
      propertySelected: {},
      bookingSelected: {},
      user: JSON.parse(localStorage.getItem('user')),
      seller: JSON.parse(localStorage.getItem('seller')),

      dataCode: '',
      dataCustomer: 0,
      dataTemplate: 0,
      dataAccountTender: 0,
      dataProperty: 0,
      dataBooking: 0,
      dataCurrency: 0,
      dataAmount: 0,
      dataDiscount: 0,
      dataDiscountType: 0,
      dataSalePrice: 0,
      dataDeposit: 0,
      dataInterest: 0,
      dataPaymentTerm: 0,
      dataPaymentMethod: 1,
      dataManualSettle: 0,
      dataUserSeller: 0,
      dataSeller: 0,
      dataAgency: 0,
      dataCommission: 0,
      dataCommissionFor: 0,
      dataPaymentStatus: 0,
      dataStartDate: this.$moment().clone().format('YYYY-MM-DD'),
      dataDate: this.$moment().clone().format('YYYY-MM-DD'),
      dataDepositDate: this.$moment().clone().format('YYYY-MM-DD'),
      dataExcludeDeposit: 0,
      dataDoc: [],
      dataBookingAmount: 0,
      
      dataSchedule: [],
      dataPost: [],

      dataLastPaytype: 0,
      dataNoInterestPayment: 0,
      dataNoInterestDuration: 0,

      selectChangePaymentTerm: null,
    };
  },
  mounted() {

    this.loadingCurrencyData();
    this.loadingDiscountTypeData();
    
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    this.dataCurrency = 1;
    this.dataDiscountType = 2;
    this.dataDiscountText = "សាច់ប្រាក់";
    this.dataPaymentStatus = 1;
    this.dataSeller = this.seller && this.seller.type_id == 1 ? this.seller.id : 0;

    // console.log("AAA", this.dataSeller);


    this.dataSchedule = [];

    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else if('propertyid' in this.$route.query) {
      this.loadingPropertyById(this.$route.query.propertyid);
      console.log('load property data ..');
    } else if('bookingid' in this.$route.query) {
      this.loadingBookingById(this.$route.query.bookingid);
      console.log('load booking data ..');
    } else {
      this.loadingData(0);     
    }
  },
  watch: {
      dataDiscount: function() { // watch it
        // console.log(newVal);
        this.changeSellPrice();
      }
  },
  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      saleService.getOne(id)
        .then(response => {

          this.fetchingStats = true;

          if(response.data) 
          {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

            this.saleData = response;

            this.dataCode = this.saleData.data.code;
            this.dataDate = this.saleData.data.sale_date;
            this.dataCustomer = this.saleData.data.customer_id;
            this.dataTemplate = this.saleData.data.template_id;
            this.dataAccountTender = this.saleData.data.payment_account_id;
            this.dataAccountsale = this.saleData.data.sale_account_id;
            this.dataProperty = this.saleData.data.property_id;
            this.dataBookingAmount = this.saleData.data.deposit;
            this.dataBooking = this.saleData.data.booking_id;
            this.dataAmount = this.saleData.data.sale_price;
            this.dataSalePrice = this.saleData.data.sale_price; // - this.saleData.data.booking_amount;
            this.dataCurrency = this.saleData.data.currency_id;
            this.dataExpired = this.saleData.data.expire_date;
            this.dataDeposit = this.saleData.data.sale_amount;
            this.dataDiscount = this.saleData.data.discount;
            this.dataDiscountType = this.saleData.data.discount_type;
            this.dataUserSeller = this.saleData.data.sale_user_id;
            this.dataExpireDate = this.saleData.data.expire_date;
            this.dataSeller = this.saleData.data.seller_id;
            this.dataAgency = this.saleData.data.seller_agency_id;
            this.dataCommission = this.saleData.data.commission_type_id;
            this.dataAccountCommissionExpense = this.saleData.data.commission_expense_account_id;
            this.dataAccountCommissionPaid = this.saleData.data.commission_paid_account_id;
            this.dataPaymentStatus = this.saleData.data.payment_status_id;
            this.dataPaymentMethod = this.saleData.data.payment_method_id;

            this.dataNoInterestPayment = this.saleData.data.no_interest_payment;
            this.dataNoInterestDuration = this.saleData.data.no_interest_duration;

            this.saleData.data.collections.map(item => {
              if('sale_attachments' in item) {
                this.dataDoc = item.sale_attachments;
              } 
            });
          } 

          this.loadingSettings(response.setting);
          
        });
    },

    loadingDiscountTypeData: function() {

      servicehelpers.getDiscountTypeData().then(response => {
        this.discountTypeData = response;
      });
    },

    loadingCurrencyData: function() {
      servicehelpers.getCurrencyData().then(response => {
        this.currencyData = response;
      });
    },

    loadingPropertyById: function(id) {

      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          this.fetchingStats = true;
          this.propertySelected = response.data;

          // console.log("AAAA", JSON.stringify(response.data));

          this.dataProject = this.propertySelected.project_id
          this.dataDiscount = 0;
          this.dataDiscountType = 2;
          this.dataBookingAmount = 0;
          this.dataBooking = 0;

          

          if('collections' in this.propertySelected ) {

            this.propertySelected.collections.map(item => {
              if('bookings' in item) {
                
                // let deposit = item.bookings[0];
                let deposit = item.bookings.slice(-1)[0];
               
                if(deposit) {

                  bookingService.isSold(deposit.id).then(response => {
                    if(!response.data) {
                      this.dataDiscount = deposit.discount;
                      this.dataDiscountType = deposit.discount_type;
                      this.dataBookingAmount = deposit.booking_amount;
                      this.dataBooking = deposit.id;
                      this.dataPaymentMethod = deposit.payment_method_id;
                      this.dataDepositDate = deposit.booking_date;

                      this.loadingBookingById(deposit.id)
                    }
                  });
                  
                }

               
              }
            });
            

          }

          // console.log(JSON.stringify(this.propertySelected));

          let discount = this.dataDiscountType == 2 ? this.dataDiscount : (this.propertySelected.price * this.dataDiscount / 100);

          this.dataCustomer = this.propertySelected.customer_id == 0 ? this.propertySelected.temp_customer_id : this.propertySelected.customer_id;
          this.dataProperty = this.propertySelected.id;
          this.dataAmount = this.propertySelected.price;
          this.dataSalePrice = this.propertySelected.price - discount; // - this.dataBookingAmount;
          this.dataCode = this.propertySelected.contract_no && this.propertySelected.contract_no != '' ? `${this.propertySelected.contract_no}R` : '';

          this.loadingSettings(response.setting);
        });
    },

    loadingBookingById: function(id) {

      this.fetchingStats = false;
      bookingService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.bookingSelected = response.data;
          this.dataProject = this.bookingSelected.project_id
          this.dataDepositDate = this.bookingSelected.booking_date;
          this.dataBooking = this.bookingSelected.id;
          this.dataProperty = this.bookingSelected.property_id;
          this.dataAmount = this.bookingSelected.price;
          this.dataSalePrice = this.bookingSelected.sale_price;
          this.dataBookingAmount = this.bookingSelected.booking_amount;
          this.dataCustomer = this.bookingSelected.customer_id;
          this.dataDiscountText = this.bookingSelected.discount_type == 2 ? 'សាច់ប្រាក់' : '%';
          this.dataDiscountType = this.bookingSelected.discount_type;
          this.dataPaymentMethod = this.bookingSelected.payment_method_id;
          this.dataDiscount = this.bookingSelected.discount_type == 2 ? this.bookingSelected.discount : 
                              this.bookingSelected.booking_amount * this.bookingSelected.discount / 100;
                              
          this.dataCode = this.bookingSelected.contract_no && this.bookingSelected.contract_no != '' ? `${this.bookingSelected.contract_no}R` : '';


          // console.log(JSON.stringify(response.data));

          this.loadingSettings(response.setting);
          
        });
    },

    loadingSchedule: function(schedule) {

      // console.log(schedule);

      scheduleService.custom(schedule)
         .then(response => {
           this.tryingToSubmit = false;

           if(response.status == 200) {
              this.dataSchedule = response.data;
              // console.log(JSON.stringify(this.dataSchedule));
           }
          
        });

    },

    loadingPropertyData: function(projectId = 0) {
      propertyService.getDropdowns(projectId).then(response => {
        this.propertyData = response;
      });
    },

    loadingSettings: function(setting) {
      //paymentmethods
      this.customerData = {data: setting.customers};
      this.projectData = {data: setting.projects};
      this.propertyData = {data: setting.properties};
      this.paymenttermData  = {data: setting.paymentterms};
      this.commissionTypeData = {data: setting.commissiontypes};
      this.templeteData = {data: setting.templates.filter((item) => item.contract_type_id == 2)};
      this.lastPayTypeData = {data: setting.lastpaytypes};

      this.sellerData = {data: []};
      this.agencyData = {data: []};

      this.sellerData['data'] = setting.sellers.filter(obj => obj.type_id == 1);
      this.agencyData['data'] = setting.sellers.filter(obj => obj.type_id != 1);

      console.log(JSON.stringify(setting.lastpaytypes));
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "sale-list"
          });

        }
      });
    
    },
    submitSave: function() {
      
      if(!this.dataCustomer && this.dataCustomer == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('customer.text') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(!this.dataProperty && this.dataProperty == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('property.text') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(!this.dataTemplate && this.dataTemplate == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('sale.contract-template') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(!this.dataLastPaytype && this.dataLastPaytype == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('sale.last-pay-type') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      }

      ///dataLastPaytype

      this.tryingToSubmit = true;

      let sale = {
        code: this.dataCode,
        customer_id: this.dataCustomer,
        template_id: this.dataTemplate,
        payment_account_id: this.dataAccountTender,
        property_id: this.dataProperty,
        currency_id: this.dataCurrency,
        amount: this.dataAmount,
        discount: this.dataDiscount,
        discount_type: this.dataDiscountType,
        sale_price: this.dataSalePrice,
        deposit: this.dataBookingAmount,
        interest: this.dataInterest,
        payment_term_id: this.dataPaymentTerm,
        manual_settle: this.dataManualSettle,
        booking_id: this.dataBooking,
        commission_type_id: this.dataCommission,
        sale_user_id: this.dataUserSeller == 0 ? this.user.id : this.dataUserSeller,
        seller_id: this.dataSeller == 0 ? this.seller.id : this.dataSeller,
        // seller_agency_id: this.dataAgency == 0 ? this.seller.id : this.dataAgency,
        seller_agency_id: this.dataAgency == 0 ? this.dataSeller : this.dataAgency,

        payment_status_id: this.dataPaymentStatus,
        sale_date: this.dataDate,
        sale_attachments: this.dataDoc,
        payment_method_id: this.dataPaymentMethod,
        exclude_deposit: this.dataExcludeDeposit,
      
        last_pay_type_id: this.dataLastPaytype,
        no_interest_duration: this.dataNoInterestDuration,
        no_interest_payment: this.dataNoInterestPayment
      };

      // console.log(JSON.stringify(sale));

      if(this.isAdd) {
        saleService.insert(sale)
         .then(response => {
           this.tryingToSubmit = false;

          //  console.log(JSON.stringify(this.dataSchedule));

           if(response.status == 200) {
              this.saveSchedule(response.data.id, this.dataSchedule, 0, () => {
                this.clearForm();
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                }).then(result => {
                  if (!result.value) {
                    this.$router.push(this.$route.query.redirectFrom || {
                      name: "sale-list"
                    });
                  }
                });
              });
           }
          
        });
      } else {

        delete sale['sale_user_id'];
        delete sale['seller_id'];
        delete sale['seller_agency_id'];

        saleService.update(this.$route.params.id, sale)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "sale-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
        
      }
    },

    saveSchedule: function(saleId, schedules, interest, callback) {
      this.dataPost = {
        sale_id: saleId,
        schedules: schedules
      };
      console.log(interest);
      scheduleService.save(this.dataPost).then(response => {
        if(response.status == 200) {
          callback();
        }
      });
    },

    clearForm: function() {

      this.dataCode = '';
      this.dataBooking = 0;
      this.dataCustomer = 0;
      this.dataTemplate = 0;
      this.dataAccountTender = 0;
      this.dataProperty = 0;
      this.dataCurrency = 0;
      this.dataAmount = 0;
      this.dataDiscount = 0;
      this.daataDiscountType = 0;
      this.dataBookingAmount = 0;
      this.dataPaymentMethod = 1;
      this.dataSalePrice = 0;
      this.dataDeposit = 0;
      this.dataInterest = 0;
      this.dataPaymentTerm = 0;
      this.dataManualSettle = 0;
      this.dataSeller = 0;
      this.dataCommission = 0;
      this.dataSeller = 0;
      this.dataAgency = 0;
      this.dataPaymentStatus = 0;
      this.dataDoc = [];
    },

    currencyChanged: function(event) {

      const cur = this.currencyData.data.find(obj => {
        return obj.id === event
      });

      this.currency = cur == null ? "" : cur.name_en;
    
    }, 

    commissionTypeChanged: function(event) {

      this.dataCommissionFor = this.commissionTypeData.data.find(obj => { return obj.id == event});
      console.log("Seller", this.dataSeller);
    },

    projectChanged: function(event) {

      this.project = event;
      if(this.dataLastProject != 0) {
        this.loadingPropertyData(this.project);
      }

      this.dataLastProject = event;
    },
    propertyChanged: function(property) {
      this.loadingPropertyById(property.id);      
    },

    discountTypeChanged: function(event) {

      const discountType = this.discountTypeData.data.find(obj => {
        return obj.id === event
      });

      this.dataDiscountText = discountType == null ? "" : discountType.name;
      // console.log(this.dataDiscountText);
      this.changeSellPrice();
    }, 

    paymenttermChange: function(event) {

      if(event == 1) {

        let index = this.paymenttermData.data.findIndex(function(i){
            return i.id == 99;
        });

        if(index >= 0) {
          this.paymenttermData.data.splice(index, 1);
        }

        this.openCustomerForm();
      } else {

        // console.log("Event" + event);
        servicehelpers.getPaymentSchedule(event).then(response => {
          this.paymentSchedule = response;
          // console.log("CCCCC", JSON.stringify(this.paymentSchedule.data));

          // console.log(this.paymentSchedule.data);
          this.generateSchedule(this.paymentSchedule.data, 1);

        });
        
      }
      
    },

    changeSellPrice: function() {
      if(this.dataDiscountType == 2) {
        this.dataSalePrice = this.dataAmount - this.dataDiscount;
      } else {
        this.dataSalePrice = this.dataAmount - (this.dataDiscount * this.dataAmount / 100);
      }
    },

    showSchedule: function() {
      this.$refs['payment-schedule'].show();
      //console.log(this.dataExcludeDeposit);
    },

    uploadDocSuccess(file, response) {
        console.log(file);
        this.dataDoc.push(response.data);
    },
    openCustomerForm() {
      this.$refs['payment-term'].reset();
      this.$refs['payment-term'].show();
    },

    generateSchedule(payment_term_details, rounding_rule_id) {

      this.loadingSchedule({
        amount: this.dataSalePrice,
        deposit: this.dataBookingAmount, 
        start_date: this.dataStartDate == '' ? this.$moment().clone().format('YYYY-MM-DD') + "" : this.dataStartDate,
        decimal_calc_type_id: rounding_rule_id,
        custome_schedule: payment_term_details.map(function(item) {
                            return item['display'];
                          }),
        deposit_type: this.dataExcludeDeposit,
        deposit_date: this.dataDepositDate,
        payment_template_id: 0
      });

    },

    getPaymentTerm(event) {
  
      let data = this.paymenttermData.data;

      data.unshift(event);
      this.paymenttermData.data = data;
      this.dataPaymentTerm = event.id;

      this.generateSchedule(data[0].payment_term_details, data[0].rounding_rule_id);

      // console.log(event);
    },

    
  },
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('sale.list'),
        href: '/general/sale',
      }, {
        text: $t('sale.new'),
        active: true
      }]" :title="this.isAdd ? $t('sale.new') : $t('sale.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('sale.list'),
        href: '/general/sale',
      }, this.breadCrumb]" :title="this.isAdd ? $t('sale.new') : $t('sale.edit')" />
    </div>
    <PaymentTerm 
      id="payment-term"
      ref="payment-term"
      :title="'viewTitle'"
      :salePrice="dataSalePrice"
      :discount="dataDiscount"
      @save="getPaymentTerm"
      v-model="selectChangePaymentTerm"
    /> 
    <PaymentSchedule 
      id="payment-schedule"
      ref="payment-schedule"
      :title="'viewTitle'"
      :schedule="dataSchedule"
      :filters="$options.filters"
    /> 
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-9">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <h4 class="card-title">{{$t('sale.text')}}</h4>
                <p class="mb-4">{{$t('sale.sub-text')}}</p>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    v-model="dataCode"
                    :label="'sale.code'" 
                    :disabled="true"
                     /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'date'"
                    :id="'sale_date'"
                    v-model="dataDate"
                    :label="'general.date'" 
                    :require="true"
                     /> 
                </div>
                <div class="col-md-3">
                  <Select 
                    :id="'template_id'"
                    :text="'name'"
                    v-model="dataTemplate"
                    :list="this.templeteData"
                    :label="'sale.contract-template'"
                    :require="true"
                     /> 
                </div>
                <div class="col-md-3">
                  <Search 
                    :id="'customer_id'"
                    :editable="false"
                    v-model="dataCustomer"
                    :list="this.customerData"
                    :require="true"
                    :label="'customer.text'"  />
                </div>
              </div>
              <div class="row">
                <div class="mb-1"><hr/></div>
                <h4 class="card-title">{{$t('sale.payment-property')}}</h4>
                <p class="mb-4"> {{$t('sale.sub-payment-property')}}</p>
              </div>
               <div class="row">
                 <div class="col-md-4">
                  <Select
                    @change="projectChanged" 
                    :id="'project_id'"
                    :auto="true"
                    :editable="false"
                    v-model="dataProject"
                    :list="this.projectData"
                    :label="'property.project'"
                     /> 
                </div>
                <div class="col-lg-4">
                  <Search 
                    @change="propertyChanged" 
                    :id="'property_id'"
                    :editable="false"
                    v-model="dataProperty"
                    :list="this.propertyData"
                    :require="true"
                    :label="'property.text'"  />
                </div>
                <div class="col-md-4">
                  <Select
                    @change="currencyChanged" 
                    :id="'currency_id'"
                    :text="'name'"
                    :auto="true"
                    :disabled="true"
                    :text2="'name_en'"
                    v-model="dataCurrency"
                    :list="this.currencyData"
                    :label="'property.currency'"
                     /> 
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <Input 
                    :type="'number'"
                    :id="'amount'"
                    :disabled="true"
                    v-model="dataAmount"
                    :last="currency"
                    :label="'sale.price'"  />
                </div>
                <div class="col-lg-8">
                  <div class="row">
                    <div class="col-lg-7">
                      <Input 
                        :type="'number'"
                        :id="'discount'"
                        v-model="dataDiscount"
                        :last="this.dataDiscountText"
                        :label="'sale.discount'"  />
                    </div>
                    <div class="col-lg-5">
                      <Select
                        @change="discountTypeChanged" 
                        :id="'discount_type'"
                        :text="'name'"
                        :auto="true"
                        v-model="dataDiscountType"
                        :list="this.discountTypeData"
                        :label="'sale.as'"
                        /> 
                    </div>
                  </div>
                </div>
                
              </div>

              <div class="row">
                <div class="col-lg-4">
                  <Input 
                    :type="'number'"
                    :id="'sale_price'"
                    :disabled="true"
                    v-model="dataSalePrice"
                    :last="currency"
                    :label="'sale.sale-price'"  />
                </div>
                <!-- <div class="col-lg-4">
                  <Input 
                    :type="'number'"
                    :id="'no_interest_payment'"
                    v-model="dataNoInterestPayment"
                    :last="currency"
                    :label="'sale.no-interest-payment'"  />
                </div>
                <div class="col-lg-4">
                  <Input 
                    :type="'number'"
                    :id="'no_interest_duration'"
                    v-model="dataNoInterestDuration"
                    :last="'general.month'"
                    :label="'sale.no-interest-duration'"  />
                </div> -->
                <div class="col-lg-8">
                  <Select 
                    :id="'last_pay_type'"
                    :required="true"
                    v-model="dataLastPaytype"
                    :list="this.lastPayTypeData"
                    :label="'sale.last-pay-type'"  />
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-4">
                  <Select 
                    :id="'payment_term_id'"
                    :required="true"
                    v-model="dataPaymentTerm"
                    :list="this.paymenttermData"
                    @change="paymenttermChange"
                    :label="'sale.payment-term'"  />
                </div>
                
                <div class="col-md-4">
                  <Input 
                    :type="'date'"
                    :id="'start_date'"
                    v-model="dataStartDate"
                    :label="'general.start-date'"  />
                    
                </div>
                <div class="col-md-4" style="margin-top: 27px">
                  <Button v-bind:icon="'bx bx-table'" 
                    v-bind:buttonType="'button'"
                     @click="showSchedule()"
                    v-bind:title="$t('sale.schedule.view')"  />
                </div>
              </div>
              <div class="row">
                
                <div class="col-md-4">
                  <Input 
                    :type="'number'"
                    :id="'deposit'"
                    :disabled="true"
                    v-model="dataBookingAmount"
                    :last="currency"
                    :label="'sale.deposit'"  />
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <b-form-group
                        class="mb-3"
                        :label="$t('sale.deposit-type')"
                        :label-for="id"
                    >
                      <div class="input-group" style="margin-left: 10px;"> 
                        <b-form-group class="input-group" id="type">
                          <div inline class="row gy-2 gx-3 align-items-end">
                          <b-form-radio
                            v-model="dataExcludeDeposit"
                            class="col-sm-auto"
                            value=0
                            plain
                            >{{$t('sale.principal-payment')}}</b-form-radio>
                          <b-form-radio
                            v-model="dataExcludeDeposit"
                            class="col-sm-auto"
                            value=1
                            plain
                            >{{$t('sale.schedule-payment')}}</b-form-radio>
                          </div>
                        </b-form-group>
                        
                      </div>
                    </b-form-group>
                  </div>
                  
          
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <Dropzone 
                    :id="'doc'"
                    :maxFiles="5"
                    :label="'sale.doc'" 
                    @uploadSuccess="uploadDocSuccess" />
                </div>
              </div>
          
              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>

          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <h4 class="card-title">{{$t('booking.commission-text')}}</h4>
              <p class="mb-4">{{$t('booking.commission-sub-text')}}</p>
            </div>
            <div class="row">
              <div class="col-md-12">
                <Select 
                    :id="'commission_id'"
                    @change="commissionTypeChanged"
                    v-model="dataCommission"
                    :list="this.commissionTypeData"
                    :label="'booking.commission-type'"  />
              </div>
            </div>
            <div v-show="dataCommissionFor.commission_for == 1 || dataCommissionFor.commission_for == 3" class="row">
              <div class="col-md-12">
                 <Select 
                    :id="'sale_user_id'"
                    v-model="dataSeller"
                    :list="this.sellerData"
                    :label="'sale.seller'"  />
              </div>
            </div>
            <div v-show="dataCommissionFor.commission_for == 2 || dataCommissionFor.commission_for == 3" class="row">
              <div class="col-md-12">
                 <Select 
                    :id="'sale_user_id_agency'"
                    v-model="dataAgency"
                    :list="this.agencyData"
                    :label="'sale.agency'"  />
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12">
                <Input 
                    :type="'number'"
                    :last="currency"
                    :id="'commission_amount'"
                    v-model="dataCommissionAmount"
                    :label="'booking.commission-amount'"  />
              </div>
            </div> -->

          </div>
        </div>

      </div>
    </b-form> 
  </Layout>
</template>